module.exports = __webpack_public_path__ + "img/3.64bee3ba.png";